// Reine Logik der App-Tour (ohne React, ohne driver.js), damit testbar.

export const VORLAGE_ID = 'zahnrad-sicherungsring-axialspiel';

/** Banner nur für angemeldete Nutzer ohne Tour-Status, nicht nach „Später“ und nicht während der Tour. */
export function bannerSichtbar({ profile, spaeter, aktiv }) {
  if (!profile || spaeter || aktiv) return false;
  return !profile.tour_status;
}

export function statusUpdate(art, jetzt = new Date()) {
  if (art !== 'done' && art !== 'dismissed') throw new Error(`unbekannter Tour-Status: ${art}`);
  return { tour_status: art, tour_status_at: jetzt.toISOString() };
}

/** Sichtbares Ziel-Element oder undefined (dann zeigt driver.js die Sprechblase mittig). */
export function zielOderNichts(selector, doc = document) {
  const el = doc.querySelector(selector);
  if (!el || el.hidden) return undefined;
  const r = el.getBoundingClientRect();
  return r.width > 0 && r.height > 0 ? el : undefined;
}

/** Plausible-Ereignis, nie werfend, nichts im Browser gespeichert. */
export function tourEreignis(aktion) {
  try { window.plausible?.('Tour', { props: { aktion } }); } catch { /* egal */ }
}
